<template>
  <div v-if="readOnly">
    <div v-if="model.properties.dropdown && !model.properties.dropdownMultiSelect" class="mb-4">
      <!--Flat-->
      <div v-if="!model.properties.multiLevel">
        <div v-for="(item, index) in model.properties.selectable" :key="$uuid(index)" :value="item.value" disabled>
          <div v-if="item.value === singleSelected">
            <div v-html="item.text" class="w-full border bg-graylight-100 p-4 rounded"/>
          </div>
        </div>
      </div>
      <!--Multilevel-->
      <div v-else>
        <div :label="item.text" v-for="item in model.properties.selectable" :key="item.value">
          <div v-for="subItem in item.children" :key="subItem.value">
            <div v-if="subItem.value === singleSelected">
              <div v-html="subItem.text" class="w-full border bg-graylight-100 p-4 rounded"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="model.properties.dropdown && !model.properties.dropdownMultiSelect" class="mb-4">
      <!--Flat-->
      <div v-if="!model.properties.multiLevel">
        <select class="p-4 bg-transparent border-2" @change="save" v-model="singleSelected">
          <option v-for="(item, index) in model.properties.selectable" :key="$uuid(index)" :value="item.value">
            {{ item.text }}
          </option>
        </select>
      </div>
      <!--Multilevel-->
      <div v-else>
        <select class="p-4 bg-transparent border-2" v-model="singleSelected" @change="save">
          <optgroup :label="item.text" v-for="item in model.properties.selectable" :key="item.value">
            <option v-for="subItem in item.children" :key="subItem.value" :value="subItem.value">
              {{ subItem.text }}
            </option>
          </optgroup>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      singleSelected: this.model.properties.singleSelected,
      selectable: this.model.properties.selectable,
    };
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    pageId: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
  },
  components: {},
  methods: {
    save() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.model.contentGuid,
          value: this.singleSelected,
          type: this.type,
          pageId: this.pageId,
          relationRule: this.model.properties.relationRule,
        }),
      };
      const self = this;
      this.isSaving = true;
      fetch(`${window.location.origin}/api/schema/SaveSchemaItem`, requestOptions)
        .then(() => {
          this.$emit('onSave');
          this.$emit('getSchema');
        }).then(() => {
        self.isSaving = false;
        this.$toast.open({
          message: 'Lagret',
          type: 'success',
          dismissible: true,
        });
      });
    },
  },
};
</script>
